import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  conditions: {
    values: [
      {
        field1: '',
        operator: '===',
        value: '',
      },
    ],
  },
  combineOperation: 'AND',
};

export default defaults;
